import { ApiGigInviteDto } from "../api/gigInvite";
import { GigInviteDto } from "../app/gigInvite";

export const mapFromApiGigInvite = (apiDto: ApiGigInviteDto): GigInviteDto => ({
    ...apiDto,
    dateSent: new Date(apiDto.dateSent),
    acceptedDate: apiDto.acceptedDate ? new Date(apiDto.acceptedDate) : undefined,
    declinedDate: apiDto.declinedDate ? new Date(apiDto.declinedDate) : undefined,
});